import { HowToSection } from 'app/src/features/Tutorial/components/HowToSection'
import { InformativeSection } from 'app/src/features/Tutorial/components/InformativeSection'
import { MoreInfoSection } from 'app/src/features/Tutorial/components/MoreInfoSection'
import { TutorialList } from 'app/src/features/Tutorial/components/TutorialList'
import { pageconfigurationsApi } from 'app/src/services/welfareportal'
import { DynamicPageWidget } from 'app/src/shared/components'
import { useWebAppContext } from 'app/src/shared/hooks'
import type { ReactElement } from 'react'

export function ComponentRenderer(sections?: pageconfigurationsApi.SectionItem[]): ReactElement {
  const context = useWebAppContext()

  return (
    <>
      {sections &&
        sections?.map((section) => {
          switch (section.sectionName) {
            case 'TutorialInformativeSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <InformativeSection {...props} />}
                  sectionItem={section}
                />
              )

            case 'TutorialMoreInfoSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <MoreInfoSection {...props} />}
                  sectionItem={section}
                />
              )
            case 'TutorialHowToSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <HowToSection {...props} />}
                  sectionItem={section}
                />
              )
            case 'TutorialVideoCarouselSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  background='lightGrayBackground'
                  componentRenderer={(props) => <TutorialList {...props} />}
                  sectionItem={section}
                />
              )
            default:
              if (section?.renderingMode !== 'native') {
                return <DynamicPageWidget key={section.sectionName} sectionItem={section} />
              } else {
                context.logger?.warn('Unknown Native Section', { section: section.sectionName })
                return <></>
              }
          }
        })}
    </>
  )
}
